"use client";

import { Currency } from "@/components/ui/currency";
import { parseAsArrayOf, parseAsString, useQueryState } from "nuqs";

export const ProductServicesSelection = ({
  availableServices,
}: {
  availableServices: {
    id: string;
    title: string;
    price: number;
    vat: number;
    visible: boolean;
  }[];
}) => {
  const services = availableServices.filter((service) => service.visible);
  const [selectedServices = [], setSelectedServices] = useQueryState(
    "services",
    parseAsArrayOf(
      parseAsString.withOptions({
        shallow: false,
      }),
      ",",
    )
      .withOptions({
        shallow: false,
        clearOnDefault: true,
      })
      .withDefault([]),
  );

  const hasServices = services.length > 0;

  if (!hasServices) {
    return null;
  }

  return (
    <div className="flex w-full flex-col">
      <h3 className="text-lg font-semibold">Zusätzliche Optionen</h3>
      {services.map((service) => (
        <Service
          key={service.id}
          id={service.id}
          title={service.title}
          price={service.price}
          vat={service.vat}
          selected={selectedServices.includes(service.id)}
          setSelected={(id, selected) => {
            setSelectedServices(
              selected
                ? [...selectedServices, id]
                : selectedServices.filter((s) => s !== id),
            );
          }}
        />
      ))}
    </div>
  );
};

const Service = ({
  id,
  title,
  price,
  vat,
  selected,
  setSelected,
}: {
  id: string;
  title: string;
  price: number;
  vat: number;
  selected: boolean;
  setSelected: (id: string, selected: boolean) => void;
}) => {
  const totalPrice = price * (1 + vat / 100);
  return (
    <label className="flex w-full items-center justify-between border border-gray-200 rounded-lg bg-white hover:bg-gray-50 hover:border-orange-300 px-4 py-4 gap-4 select-none">
      <input
        type="checkbox"
        checked={selected}
        onChange={(e) => setSelected(id, e.target.checked)}
      />
      <div className="flex w-full grow flex-row justify-between">
        <div className="flex flex-col">
          <span className="text-sm font-semibold">{title}</span>
          <span className="text-xs text-gray-500">inkl. {vat}% MwSt.</span>
        </div>
        <div className="flex flex-col">
          <span className="text-sm font-semibold">
            <Currency amount={totalPrice} />
          </span>
        </div>
      </div>
    </label>
  );
};
